import { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { useAuthStore, isInstructor } from './store/auth';
import LoginPage from './views/LoginPage';
import SetPasswordScreen from './views/SetPasswordScreen';
import Layout from './components/Layout';

/**
 * Point d'entrée : consomme un éventuel lien magique présent dans l'URL
 * (`/auth/verify?token=…`), puis affiche l'espace connecté, l'écran de création
 * de mot de passe (première connexion) ou la page de connexion.
 */
export default function App() {
  const user = useAuthStore((s) => s.user);
  const token = useAuthStore((s) => s.token);
  const verify = useAuthStore((s) => s.verify);
  const [checkingLink, setCheckingLink] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const magicToken = params.get('token');
    if (!magicToken) return;
    setCheckingLink(true);
    void verify(magicToken).finally(() => {
      // Nettoie l'URL (retire le token) sans recharger la page.
      const url = new URL(window.location.href);
      url.searchParams.delete('token');
      window.history.replaceState({}, '', url.pathname + url.search);
      setCheckingLink(false);
    });
  }, [verify]);

  if (checkingLink) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="animate-spin text-indigo-600" size={28} />
      </div>
    );
  }

  if (!token || !isInstructor(user)) {
    return <LoginPage />;
  }

  // Première connexion (lien magique) : proposer la création du mot de passe.
  if (user && user.passwordChosen === false) {
    return <SetPasswordScreen />;
  }

  return <Layout />;
}
